export const handleUrl = (data: { url: string, isLaunchedUrl: boolean, componentId: string }) => {
    const { url, isLaunchedUrl, componentId } = data;
    if ((url !== undefined) && (url !== null)) { }
}